import './style.scss'
import dayjs from 'dayjs';
import { useState, useEffect, useRef } from 'react';
import { Button, Tooltip, Flex, Spin} from 'antd'
import {
    FullscreenOutlined, 
    FullscreenExitOutlined,
    LinkOutlined,
    DisconnectOutlined,
    AimOutlined,
    ArrowUpOutlined,
    ArrowLeftOutlined,
    ArrowRightOutlined,
    ArrowDownOutlined,
    LoadingOutlined,
    PlusOutlined,
    MinusOutlined,
    HomeOutlined,
    PauseCircleOutlined,
    PlayCircleOutlined,
    PaperClipOutlined,
    DownOutlined
} from '@ant-design/icons'
import {
    capitalizeFirstLetter
} from '../../utils'

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import utc from 'dayjs/plugin/utc'; // Import UTC plugin for dayjs
import timezone from 'dayjs/plugin/timezone'; // Import timezone plugin for dayjs
import ArrowButton from "./ArrowButton";
import 'dayjs/locale/en'; // Import the locale you want to use
import { useVideoContext } from "./VideoContext"; // Import the context hook
import axios from 'axios'; // Needed only for axios.isCancel
import { apiClient } from '../../api_actions';
dayjs.extend(utc); // Enable the UTC plugin
dayjs.extend(timezone); // Enable the timezone plugin
import Archive from './Archive';
import { useIsSuperAdmin ,useIsAdmin, useMobileStore, } from '../../store';

import LoadingOrbitalSpinner from '../../components/LoadingOrbitalSpinner/LoadingOrbitalSpinner';

function Stream({
    camera_type,
    camera_name,
    index,
    streamId,
    highResID,
    periscopeID,
    unix_timestamp_s,
    onPromoteToggle,      // NEW
    isPromoted,           // NEW
    canPromote,           // NEW
    promotedCount,         // NEW
    location_name,
}) {
    const {
        videoRefs,
        linkedStreams,
        setLinkedStreams,
        masterPlaybackModeRef,
        masterPlaybackStart,
        initializeHLS,
        streamErrors,
        destroyHLS,
        setCancelSignal,
        goLiveAll,
        setStreamErrors,
        streamLoading,
        windowStartMs,
        currentTimePointer,
        updateVideoState,
        attachVideoListeners,
        masterSpeed,
        isHighspeed
    } = useVideoContext();

    const [isReady, setIsReady] = useState(false);
    const videoRef = useRef(null);
    const cameraOverlayRef = useRef(null)
    const [linked, setLinked] = useState(true)
    
    const [showCameraMoveControls, setShowCameraMoveControls] = useState(false)
    const streamSessionRef = useRef(0);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const containerRef = useRef(null);
    const isMobile = useMobileStore((state) => state.isMobile);

    let liveStream = process.env.REACT_APP_STREAM_URL + 'streams/rtsp/' + streamId
    let highresStream = process.env.REACT_APP_STREAM_URL + 'streams/rtsp/' + highResID
    let playbackStream = process.env.REACT_APP_PLAYBACK_URL + 'autoPlayback/' + streamId + '/' + masterPlaybackStart + '/'+ masterSpeed.current +'/output.m3u8' || ''

    const disableDate = current => {
        const today = dayjs().endOf('day');
        const twentyDaysAgo = dayjs().subtract(20, 'day').startOf('day');

        // Disable if before 20 days ago
        if (current < twentyDaysAgo) return true;

        // Disable if after today
        if (current > today) return true;

        // Otherwise allowed
        return false;
    };


    const disabledTime = (current) => {
        const now = dayjs();
        
        // Only restrict time if it's today
        if (!current || !current.isSame(now, 'day')) {
            return {}; // No time restrictions for other days
        }
    
        // For today, disable future times
        const currentHour = now.hour();
        const currentMinute = now.minute();
        const currentSecond = now.second();
    
        return {
            disabledHours: () => {
            // Disable hours after current hour
            return Array.from({ length: 24 }, (_, i) => i).filter(h => h > currentHour);
            },
            disabledMinutes: (selectedHour) => {
            // If selected hour is current hour, disable future minutes
            if (selectedHour === currentHour) {
                return Array.from({ length: 60 }, (_, i) => i).filter(m => m > currentMinute);
            }
            return [];
            },
            disabledSeconds: (selectedHour, selectedMinute) => {
            // If selected hour and minute are current, disable future seconds
            if (selectedHour === currentHour && selectedMinute === currentMinute) {
                return Array.from({ length: 60 }, (_, i) => i).filter(s => s > currentSecond);
            }
            return [];
            }
        };
    };

    const handleLink = () => {
        if (linked) {
            setLinked(!linked)
            const indexToRemove = linkedStreams.indexOf(+index);
            if (indexToRemove !== -1) {
                const newLinkedStreams = linkedStreams.filter(item => item !== index)
                setLinkedStreams(newLinkedStreams)
            }
        } else {
            setLinked(!linked)
            setLinkedStreams(prevStreams => [index, ...prevStreams]);
        }
    }

    const toggleFullscreen = () => {
        if (!document.fullscreenElement) {
            containerRef.current?.requestFullscreen?.();
        } else {
            document.exitFullscreen();
        }
    };

      useEffect(() => {
        const handleFullscreenChange = () => {
        setIsFullscreen(!!document.fullscreenElement);
        };
        
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
    }, []);

    const sendCameraMove = async ({ xMove, yMove, zMove }) => {
        goLiveAll()
        try{
            await apiClient.post("ovms/command", {
                "stream_id":periscopeID,
                "unix_start":Date.now(),
                "profile_name":"H.264",
                "profile_idx":0,
                "command":"nudge",
                "settings":{
                    "x_position":xMove,
                    "y_position":yMove,
                    "z_position":zMove
                },
                "status":"submitted"
            })
        } catch (error) {
            console.log(error)
        }
    }

    const sendGoHome = async () => {
        goLiveAll()

        await apiClient.post("ovms/command", {
            "stream_id":periscopeID,
            "unix_start":Date.now(),
            "profile_name":"H.264",
            "profile_idx":0,
            "command":"go_home",
            "settings":[],
            "status":"submitted"
        })
    }

    useEffect(() => {
        setLinkedStreams(prevStreams => [index, ...prevStreams]);
    }, [])

    useEffect(() => {
        const controller = new AbortController();
        const currentSessionId = ++streamSessionRef.current;
        let cancelled = false;
        setCancelSignal(controller.signal)

        if (camera_type !== 'ptz_camera') {
            setShowCameraMoveControls(false)
        }

        const updateStream = async () => {
            destroyHLS(index);            
            updateVideoState(index, { ready: false, paused: true, currentAbs: null });
            if (masterPlaybackModeRef.current === 'live') {
                setStreamErrors({})
                let newLiveFeed = liveStream
                
                initializeHLS(index, newLiveFeed, {highresStream: highresStream});
                const v = videoRefs.current[index];
                if (v) attachVideoListeners(v, index);
            } else {
                setShowCameraMoveControls(false)
                try {
                    const current_playback = playbackStream;
                    if (!cancelled && streamSessionRef.current === currentSessionId && current_playback) {
                        initializeHLS(index, current_playback, {resumeAbsMs: currentTimePointer});
                        const v = videoRefs.current[index];
                        if (v) attachVideoListeners(v, index);
                        if (v.readyState >= 1) {
                            updateVideoState(index, { ready: true });
                          }
                    } else {
                        //console.log(`[${index}] Ignored stale stream init`);
                    }
                } catch (err) {
                    if (axios.isCancel(err)) {
                        //console.log(`[${index}] Axios request cancelled`);
                    } else {
                        //console.error(`[${index}] Failed to fetch playback stream:`, err);
                    }
                }
            }
        };

        updateStream();

        return () => {
            cancelled = true;
            controller.abort(); // cancel Axios
            destroyHLS(index);
        };
    }, [
        index,
        streamId,
        masterPlaybackModeRef.current,
        windowStartMs,
        //masterSpeed.current
        isHighspeed.current
    ]);

return (
        
        <div ref={containerRef} className='player vertical-center'>
            {!(isMobile && index !== 0) && //This removes the headers from non-main cameras on the mobile
            
            <div className={`video-header row vertical-center`}  style={isMobile ? { transform: 'translateY(0)', opacity: 1, transition: 'none' } : {}}>
                <div className='video-header-left'>
                    <span>{`${camera_name ? capitalizeFirstLetter(camera_name?.replace(/_/g, ' ').replace(/\s(\.)/g, ',')) : ''} | ${location_name}`}</span>
                    {
                        (index === 0) &&
                        <Tooltip
                            title="Toggle Fullscreen"
                            placement='right'
                        >
                        <Button 
                            ghost
                            onClick={() => {
                                toggleFullscreen()
                            }                            
                            }
                            style={{ outline: 'none', boxShadow: 'none',border: 'none' }}
                            >
                            {isFullscreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
                            
                        </Button>
                        </Tooltip>
                    }
                                    
                </div>
                
                <div className='video-header-right'>
                    <div>
                        {
                            (camera_type === 'ptz_camera' && +index === 0 && masterPlaybackModeRef.current === "live") &&
                            <Tooltip
                                title="Camera Controls"
                                placement='left'
                            >
                                <Button
                                    className='video-header-button'
                                    ghost
                                    onClick={() => setShowCameraMoveControls(!showCameraMoveControls)}
                                >
                                    <AimOutlined />
                                </Button>
                            </Tooltip>
                        }
                        {
                            canPromote && (
                                <Tooltip
                                    title={
                                        isPromoted 
                                            ? "Move to carousel" 
                                            : promotedCount >= 1 
                                                ? "Maximum 1 stream can be expanded" 
                                                : "Expand to main view"
                                    }
                                    placement='left'
                                >
                                    <Button
                                        className='video-header-button'
                                        ghost
                                        disabled={!isPromoted && promotedCount >= 1}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onPromoteToggle(index);
                                        }}
                                    >
                                        {isPromoted ? <DownOutlined/> : <PaperClipOutlined/>}
                                    </Button>
                                </Tooltip>
                            )
                        }
                        {
                            <Archive
                                disableDate={disableDate}
                                disableTime={disabledTime}
                                periscopeStreamID={periscopeID}
                                lowresStreamID={streamId}
                            />
                        }
                        {
                            <Tooltip
                                title="Pause"
                                placement='left'
                            >
                                <Button
                                    className='video-header-button'
                                    ghost
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (videoRefs.current[index].paused){
                                            videoRefs.current[index].play()
                                        } else {
                                            videoRefs.current[index].pause()
                                        }
                                    }}
                                >
                                    {videoRefs.current[index]?.paused ? <PlayCircleOutlined /> : <PauseCircleOutlined />}
                                </Button>
                            </Tooltip>
                        }
                    </div>
                </div>
                
            </div>
            }
            
            {index === 0  || isPromoted ? (
                <TransformWrapper 
                    initialScale={1}     
                    pinch={{
                        step: 10,              // Moderate touch pinch sensitivity
                        disabled: false       // Enable pinch zoom
                    }}>
                    <TransformComponent
                        wrapperStyle={{
                            width: '100%',
                            height: '100%'
                        }}
                        contentStyle={{
                            width: '100%',
                            height: '100%'
                        }}
                    >
                        <video
                            id={index}
                            autoPlay 
                            muted
                            playsInline
                            loop={false}
                            controls={!linked}
                            ref={(el) => {
                                videoRefs.current[index] = el;
                                videoRef.current = el;
                            }}
                            style={{ 
                                display: 'block',
                                opacity: isReady ? (videoRefs.current[index]?.paused ? 0.5 : 1) : 0,
                                transition: 'opacity 0.3s'
                            }}
                            onCanPlay={() => setIsReady(true)}
                            onLoadStart={() => setIsReady(false)}
                            onClick={() => {
                                videoRefs.current[index]?.paused && (
                                    videoRefs.current[index]?.play()
                                )}}
                        />
                    </TransformComponent>
                </TransformWrapper>
            ) : (
                <video
                    id={index}
                    autoPlay 
                    muted
                    playsInline
                    loop={false}
                    controls={!linked}
                    ref={(el) => {
                        videoRefs.current[index] = el;
                        videoRef.current = el;
                    }}
                    style={{ 
                        display: 'block',
                        opacity: isReady ? (videoRefs.current[index]?.paused ? 0.5 : 1) : 0,
                        transition: 'opacity 0.3s'
                    }}
                    onCanPlay={() => setIsReady(true)}
                    onLoadStart={() => setIsReady(false)}
                    onClick={() => {
                        videoRefs.current[index]?.paused && (
                            videoRefs.current[index]?.play()
                        )}}
                />
            )}

            
            {videoRefs.current[index]?.paused && isReady && (
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    color: 'white',
                    fontSize: '5vw',  // 5% of viewport width
                    fontWeight: 'bold',
                    textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
                    pointerEvents: 'none'
                }}>
                <PauseCircleOutlined />
                </div>
                
            )}
            {(streamErrors[index] || streamLoading[index]) &&

                <div
                    className='video-overlay vertical-center'
                >
                    <div >
                        {streamErrors[index] &&
                            <>
                                {streamErrors[index]}
                            </>
                        }
                        {streamLoading[index] &&
                            <div className='row'>
                                <Flex align="center" gap="middle">
                                    
                                    {!isMobile && streamLoading[index]}
                                    <Spin indicator={<LoadingOrbitalSpinner />} />
                                </Flex>
                            </div>
                        }
                    </div>
                </div>
            }

            {
                (showCameraMoveControls) &&
                <div ref={cameraOverlayRef} className='camera-controls-overlay column' >
                    <div className='controls-container'>
                        <Tooltip
                            title='Move Up'
                        >
                        <ArrowButton
                            icon={<ArrowUpOutlined />}
                            className="arrowBtn arrowUp"
                            onShortClick={() => sendCameraMove({ xMove: 0, yMove: -0.05, zMove: 0 })}
                            onLongClick={() => sendCameraMove({ xMove: 0, yMove: -0.25, zMove: 0 })}
                        />
                        </Tooltip>
                        <div className='row vertical-center'>
                        <Tooltip
                            title='Move Left'
                        >
                        <ArrowButton
                            icon={<ArrowLeftOutlined />}
                            className="arrowBtn arrowLeft"
                            onShortClick={() => sendCameraMove({ xMove: -0.05, yMove: 0, zMove: 0 })}
                            onLongClick={() => sendCameraMove({ xMove: -0.25, yMove: 0, zMove: 0 })}
                        />
                        </Tooltip>
                        <Tooltip
                            title="Go Home"
                        >
                        <ArrowButton
                            icon={<HomeOutlined/>}
                            className='arrowBtn center-circle'
                            onShortClick={() => {}}
                            onLongClick={() => sendGoHome()}

                        />
                        </Tooltip>
                        <Tooltip
                            title='Move Right'
                        >
                        <ArrowButton
                            icon={<ArrowRightOutlined />}
                            className="arrowBtn arrowRight"
                            onShortClick={() => sendCameraMove({ xMove: 0.05, yMove: 0, zMove: 0 })}
                            onLongClick={() => sendCameraMove({ xMove: 0.25, yMove: 0, zMove: 0 })}
                        />
                        </Tooltip>
                        </div>
                        <Tooltip
                            title='Move Down'
                        >
                        <ArrowButton
                            icon={<ArrowDownOutlined />}
                            className="arrowBtn arrowDown"
                            onShortClick={() => sendCameraMove({ xMove: 0, yMove: 0.05, zMove: 0 })}
                            onLongClick={() => sendCameraMove({ xMove: 0, yMove: 0.25, zMove: 0 })}
                        />
                        </Tooltip>
                        <div>
                            <Tooltip
                                title='Zoom Out'
                            >
                                <ArrowButton
                                    icon={<MinusOutlined />}
                                    className="arrowBtn"
                                    onShortClick={() => sendCameraMove({ xMove: 0, yMove: 0, zMove: -0.05 })}
                                    onLongClick={() => sendCameraMove({ xMove: 0, yMove: 0, zMove: -0.25 })}
                                />

                            </Tooltip>
                            <Tooltip
                                title='Zoom In'
                            >
                                <ArrowButton
                                    icon={<PlusOutlined />}
                                    className="arrowBtn"
                                    onShortClick={() => sendCameraMove({ xMove: 0, yMove: 0, zMove: 0.05 })}
                                    onLongClick={() => sendCameraMove({ xMove: 0, yMove: 0, zMove: 0.25 })}
                                />
                            </Tooltip>
                        </div>
                    </div>
                </div>
            }

            {/* <Tooltip
                title='Link/Unlink'
            >
                {
                    linked ?
                        <Button
                            onClick={() => handleLink()}
                            ghost
                            className='link-button'
                        >
                            <DisconnectOutlined
                            />
                        </Button>
                        :
                        <Button
                            onClick={() => handleLink()}
                            ghost
                            className='link-button'
                        >
                            <LinkOutlined />
                        </Button>
                }
            </Tooltip> */}
        </div>
    )
}


export default Stream